import {
    CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS,
    CORE_LOAD_ALL_FBS_CATEGORY_REQUEST,
} from '../../types'

const initialState = []
export default {
    fbsCategory:(state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_FBS_CATEGORY_REQUEST:
                return initialState

            case CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return [{}]

            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/fbsCategory/reducer.js